import { Component, OnInit, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { State, AddressList } from 'src/app/modules/user-profile/models/contact-oeds-person.model';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';
import { ContactDataService } from 'src/app/modules/user-profile/services/contact-data-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContactVerificationAddressFormComponent } from '../contact-verification-address-form/contact-verification-address-form.component';
import { DeleteConfirmationComponent } from '../../../../../shared/components/delete-confirmation/delete-confirmation.component';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from '../../../../../shared/components/alert/alert.component';



@Component({
    selector: 'app-contact-verification-address',
    templateUrl: './contact-verification-address.component.html',
    styleUrls: ['./contact-verification-address.component.css'],
    imports: [AlertComponent, FormsModule, DeleteConfirmationComponent, ContactVerificationAddressFormComponent]
})
export class ContactVerificationAddressComponent implements OnInit {
  private router = inject(Router);
  cservice = inject(ContactVerificationService);
  private cdataservice = inject(ContactDataService);
  private spinner = inject(NgxSpinnerService);


  showDelete = false;
  showAddressForm = false;
  showAlert = false;

  routeFlag = false;
  addresslist: AddressList[];
  homephysicaladdress: AddressList;
  homemailingaddress: AddressList;
  officephysicaladdress: AddressList;
  officemailingaddress: AddressList;
  exaddress: AddressList;
  number = 0;

  ngOnInit(): void {
    this.addresslist = this.cservice.oedsPersonCopy.addressList;
    this.getAndAssignDefault();
    this.getStatesList();
    // this.resetOfficeAddress();
  }
  resetOfficeAddress() {
    if (!this.cservice.isUserOrgMappingExist) {
      this.confirmDelete(1, 4, 3);
      this.confirmDelete(2, 4, 2);
    }
  }
  //Address
  // Physical = 1,
  // Mailing = 2
  //Location
  //Home = 3,
  //Office = 4

  getAndAssignDefault() {
    this.homephysicaladdress = this.cservice.filterAddressByType(1, 3, this.addresslist)[0];
    if (!this.homephysicaladdress) {
      this.homephysicaladdress = {} as AddressList;
      this.cservice.assignDefaultAddress(this.homephysicaladdress);
      this.homephysicaladdress.oedsAddressType = 1;
      this.homephysicaladdress.oedsLocationType = 3;
      this.addresslist.push(this.homephysicaladdress);
    }

    this.homemailingaddress = this.cservice.filterAddressByType(3, 3, this.addresslist)[0];
    if (!this.homemailingaddress) {
      this.homemailingaddress = {} as AddressList;
      this.cservice.assignDefaultAddress(this.homemailingaddress);
      this.homemailingaddress.oedsAddressType = 3;
      this.homemailingaddress.oedsLocationType = 3;
      this.addresslist.push(this.homemailingaddress);
    }
    this.officephysicaladdress = this.cservice.filterAddressByType(1, 4, this.addresslist)[0];
    if (!this.officephysicaladdress) {
      this.officephysicaladdress = {} as AddressList;
      this.cservice.assignDefaultAddress(this.officephysicaladdress);
      this.officephysicaladdress.oedsAddressType = 1;
      this.officephysicaladdress.oedsLocationType = 4;
      this.addresslist.push(this.officephysicaladdress);
    }
    if (this.officephysicaladdress.oedsAddressKey !== 0) {
      this.cservice.hasOfficePhysicalAddress = true;
    }
    this.officemailingaddress = this.cservice.filterAddressByType(3, 4, this.addresslist)[0];
    if (!this.officemailingaddress) {
      this.officemailingaddress = {} as AddressList;
      this.cservice.assignDefaultAddress(this.officemailingaddress);
      this.officemailingaddress.oedsAddressType = 3;
      this.officemailingaddress.oedsLocationType = 4;
      this.addresslist.push(this.officemailingaddress);
    }
    if (this.officemailingaddress.oedsAddressKey !== 0) {
      this.cservice.hasOfficeMailingAddress = true;
    }
  }
  getStatesList() {
    if (this.cservice.statesList.length === 0) {
      this.spinner.show();
      this.cdataservice.getStatesList().subscribe({
        next: (stateslist: State[]) => {
          this.cservice.statesList = stateslist;
          this.spinner.hide();
        },
        error: (error) => {
          this.spinner.hide();
          this.cservice.contactVerificationFailed = true;
        }
      });
    }
  }
  delete(value: number) {
    if (this.cservice.action === 'Delete' + value) {
      this.cservice.action = 'List';
      this.showDelete = true;
    } else {
      this.cservice.action = 'Delete' + value;
      this.showAddressForm = false;
      this.showAlert = false;
    }
  }

  confirmDelete(addType, locType, value: number) {
    this.cservice.deleteAddressByType(addType, locType, this.addresslist);
    value = value + 1;
    this.delete(value);
  }
  cancelUpdate() {
    this.cservice.action = 'List';
    this.showDelete = true;
  }
  address(selectedaddress: AddressList, number) {
    if (this.cservice.action === 'Address' + number) {
      this.cservice.action = 'List';
      this.showDelete = true;
    } else {
      this.cservice.action = 'Address' + number;
      this.showDelete = false;
      this.showAlert = false;
    }
    this.number = number;
    if (selectedaddress.oedsAddressKey !== 0)
      selectedaddress.actionType = 'Updated'
    this.cservice.selectedaddress = selectedaddress;
  }
  alert(number) {
    if (this.cservice.action === 'Alert' + number) {
      this.cservice.action = 'List';
      this.showAlert = true;
    } else {
      this.cservice.action = 'Alert' + number;
      this.showDelete = false;
      this.showAddressForm = false;
    }
  }
  updatestepcount(isnext) {
    this.cservice.action = "";
    if (isnext) {
      this.cservice.setStep('Phone');
      this.cservice.stepCount++;
    }
    else {
      this.cservice.isBackNav = true;
      if (this.cservice.isUserOrgMappingExist || this.cservice.hasOfficeEmail) {
        this.cservice.setStep('Office Email');
        this.cservice.stepCount--;
      }
      else {
        this.cservice.setStep('Personal Email');
        this.cservice.stepCount--;
      }
    }
  }
  getIsFormvalid() {
    //If User org mapping exists then we should include office address valdations
    //if (this.cservice.isUserOrgMappingExist === true) {
    if ((this.homemailingaddress.addressI === null || this.homemailingaddress.addressI === "")
      && (this.homephysicaladdress.addressI === null || this.homephysicaladdress.addressI === "")
      && (this.officephysicaladdress.addressI === null || this.officephysicaladdress.addressI === "")
      && (this.officemailingaddress.addressI === null || this.officemailingaddress.addressI === ""))
      return true
    else if (
      (!this.homemailingaddress || this.homemailingaddress.actionType === "Deleted" || ((this.homemailingaddress.oedsAddressKey === 0 && this.homemailingaddress.isConfirm === false) || (this.homemailingaddress.oedsAddressKey !== 0 && (this.homemailingaddress.isConfirm === true || this.homemailingaddress.actionType === "Updated"))))
      &&
      (!this.homephysicaladdress || this.homephysicaladdress.actionType === "Deleted" || ((this.homephysicaladdress.oedsAddressKey === 0 && this.homephysicaladdress.isConfirm === false) || (this.homephysicaladdress.oedsAddressKey !== 0 && (this.homephysicaladdress.isConfirm === true || this.homephysicaladdress.actionType === "Updated"))))
      &&
      (!this.officemailingaddress || this.officemailingaddress.actionType === "Deleted" || ((this.officemailingaddress.oedsAddressKey === 0 && this.officemailingaddress.isConfirm === false) || (this.officemailingaddress.oedsAddressKey !== 0 && (this.officemailingaddress.isConfirm === true || this.officemailingaddress.actionType === "Updated"))))
      &&
      (!this.officephysicaladdress || this.officephysicaladdress.actionType === "Deleted" || ((this.officephysicaladdress.oedsAddressKey === 0 && this.officephysicaladdress.isConfirm === false) || (this.officephysicaladdress.oedsAddressKey !== 0 && (this.officephysicaladdress.isConfirm === true || this.officephysicaladdress.actionType === "Updated"))))
    )
      return false;
    else
      return true;
    //}
    //else {
    //  if ((this.homemailingaddress.addressI === null || this.homemailingaddress.addressI === "")
    //    && (this.homephysicaladdress.addressI === null || this.homephysicaladdress.addressI === ""))
    //    return true
    //  else if (
    //    (!this.homemailingaddress || this.homemailingaddress.actionType === "Deleted" || ((this.homemailingaddress.oedsAddressKey === 0 && this.homemailingaddress.isConfirm === false) || (this.homemailingaddress.oedsAddressKey !== 0 && (this.homemailingaddress.isConfirm === true || this.homemailingaddress.actionType === "Updated"))))
    //    &&
    //    (!this.homephysicaladdress || this.homephysicaladdress.actionType === "Deleted" || ((this.homephysicaladdress.oedsAddressKey === 0 && this.homephysicaladdress.isConfirm === false) || (this.homephysicaladdress.oedsAddressKey !== 0 && (this.homephysicaladdress.isConfirm === true || this.homephysicaladdress.actionType === "Updated"))))
    //   )
    //    return false;
    //  else
    //    return true;
    //}
  }
}
